import React from 'react';
import styled from 'styled-components';
import {TypographyChildrenProps} from './Typography';
import {CombinedTextColorProps, useCombinedTextColor} from 'epic-ue-theme';

interface TypographyButtonProps {
    big?: boolean;
}

const Button = styled.span<TypographyButtonProps & CombinedTextColorProps>`
    font-family: ${(p) => p.theme.fonts.brutal.bold};
    font-weight: 500;
    letter-spacing: 2px;
    font-size: 13px;
    line-height: 16px;
    text-transform: uppercase;
    margin: 0;
    color: ${(p) => useCombinedTextColor(p.color)};
`;

export const TypographyButton = ({
    children,
    color,
    big,
    as,
    className = ''
}: TypographyChildrenProps & TypographyButtonProps): JSX.Element => {
    return (
        <Button className={`${className} button`} color={color} big={big} as={as}>
            {children}
        </Button>
    );
};
